import React, { Component } from 'react';
import Table from '../../../components/common/Table';

const openRateClass = [];
openRateClass[0] = "active above-avg";
openRateClass[1] = "active avg";
openRateClass[2] = "active below-avg";
openRateClass[3] = "active danger";

const facebook_app_graph_url = process.env.REACT_APP_FB_URL;

class SubscribersTable extends Component {

    render() {

        const { subscribers, onClick, onSort, sortColumn } = this.props;
        const columns = [
            {path: "subscriber_name", label: "Subscriber",
                //content: item => <div><img src={item.profile_pic ? item.profile_pic : "/img/user-default.jpg"} alt="Profile Pic" height="42" width="42"/>
                //    {item.subscriber_name}
                 content: item => <div><img src={facebook_app_graph_url + item.fb_id_subscriber+"/picture?type=square&access_token="+item.page_tok
                 || "/img/user-default.jpg"} alt="Profile Pic" height="42" width="42"/>
                    {item.subscriber_name}
                </div>},
            {path: "type_of_subscription", label: "Subscription",
                content: item => <span
                    onClick={() => onClick(item)}
                    className={item.unsubscribe ? "unsubscribed" : (item.type_of_subscription === "daily") ? "daily" : (item.type_of_subscription === "weekly") ? "weekly" : "immediate"}
                >
                    {item.unsubscribe ? 'unsubscribed' : item.type_of_subscription}
                </span>},
            {path: "gender", label: "Gender"},
            {path: "timezone", label: "Timezone"},
            {path: "created_at", label: "Registered"},
           // {path: "open_rate", label: "Open Rate",
           //  content: item => <div>
           //      <div className={item.open_rate_class || openRateClass[2]}></div>
           //      {item.open_rate || "0%"}
           //      </div>},
           //  {path: "distribution_method", label: "Distribution Method",
           //      content: item => <div>
           //          <span className="fab fa-facebook-messenger"></span>{item.page_name || "STILL NULL"}
           //      </div>}
        ];
        return (

                <Table
                    data={subscribers}
                    columns={columns}
                    sortColumn={sortColumn}
                    onSort={onSort}
                    onClick={onClick}/>
        );
    }
}

export default SubscribersTable
